@if (!hideView) {
<a
  class="btn view"
  [routerLink]="viewLink"
  [queryParams]="viewLinkQuery"
  size="small"
  (click)="view.emit()"
>
  <un-icon type="eye" theme="outline"></un-icon>
  <span i18n="@@view">View</span>
</a>
} @if (!hideEdit) {
<a
  class="btn edit"
  [routerLink]="editLink"
  [queryParams]="editLinkQuery"
  size="small"
  (click)="edit.emit()"
>
  <un-icon type="form" theme="outline"></un-icon>
  <span i18n="@@edit">Edit</span>
</a>
} @if (!hideDelete) {
<div
  class="btn delete"
  type="error"
  size="small"
  nz-popconfirm="This action can not be reverse?"
  i18n-nz-popconfirm="@@thisActionCanNotBeReverse"
  [nzPopconfirmOrigin]="el"
  nzOkText="Delete"
  i18n-nzOkText="@@delete"
  [nzOkDanger]="true"
  (nzOnConfirm)="delete.emit()"
>
  <un-icon type="delete" theme="outline"></un-icon>
</div>
}
